import { render } from "./PRCarouselV2.vue?vue&type=template&id=dbfb6692&ts=true&lang=pug"
import script from "./PRCarouselV2.vue?vue&type=script&lang=ts"
export * from "./PRCarouselV2.vue?vue&type=script&lang=ts"

import "./PRCarouselV2.vue?vue&type=style&index=0&id=dbfb6692&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__